import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useGetFreights, {
  GetFreightsResponse,
} from '../../hooks/freights/useGetFreights';
import ActivityIndicator from '../ActivityIndicator';
import useSendNotification from '../../hooks/push-notification/useSendNotification';
import ModalDriverNotification from '../Modal/ModalDriverNotification';
import useGetDrivers from '../../hooks/driver/useGetDrivers';
import {
  Box,
  Grid,
  Paper,
  createStyles,
  makeStyles,
  styled,
} from '@material-ui/core';
import ButtonComponent from '../atoms/button';
import commons from '../../assets/styles/commons';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';

import { ReactComponent as SearchIcon } from '../../assets/icons/icon-search.svg';
import FilterIcon from '../../assets/icons/icon-filter.svg';
import ImportIcon from '../../assets/icons/icon-cloud-upload.svg';
import { Table } from '..';
import {
  FREIGHTS_HEADERS,
  INTERNAL_FREIGHTS_HEADERS,
} from '../../constants/table-headers';
import { FreightStatus } from '../../types/drawer.types';
import ItemsPerPageSelect from '../atoms/itemsPerPageSelect';
import Pagination from '../atoms/pagination';
import BoxWrapper from '../atoms/boxWrapper';
import { checkAdmin } from '../../services/validation';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import DateRangerCustom from '../atoms/dateRangerCustom';
import SelectCustom from '../atoms/selectCustom';
import { addDays, format } from 'date-fns';
import useDeleteFreight from '../../hooks/freights/useDeleteFreight';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Tab } from '@mui/material';
import { freightTypeEnum } from '../../hooks/freights/useConfigureFreight';

const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      marginRight: '8px',
      marginLeft: '8px',
    },
  }),
);

const TabListCustom = styled(TabList)(() => ({
  '& .MuiTabs-flexContainer': {
    display: 'flex',
  },
}));

const TabCustom = styled(Tab)(() => ({
  '&.MuiTab-root': {
    flex: 1,
    textTransform: 'none',
    fontFamily: commons.fontFamily,
    fontWeight: 700,
    color: '#2E3A59',
  },
}));

enum TabTypesEnum {
  INTERNAL = 'Internal',
  OUTSOURCE = 'Outsource',
}

const TableFreights: React.FC = () => {
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [totalRecords, setTotalRecords] = useState<number>();
  const [status, setStatus] = useState('Todos');
  const [period, setPeriod] = useState<{
    startDate: Date | undefined;
    endDate: Date | undefined;
  }>({
    startDate: undefined,
    endDate: undefined,
  });
  const [searchLoadNumber, setSeachLoadNumber] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { execute, loading } = useGetFreights();
  const { execute: sendNotification } = useSendNotification();
  const { execute: getDriver } = useGetDrivers();
  const { deleteFreight, loading: deleteFreightLoading } = useDeleteFreight();
  const [showDeleteMessage, setShowDeleteMessage] = useState(false);
  const [drivers, setDrivers] = useState<any>({
    rows: [],
    totalRecords: 0,
    page: 1,
  });

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const { execute: getDrivers } = useGetDrivers();
  const classes = useStyles();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const isAdmin = checkAdmin(token); // Check if the user is an admin
  const [freightTab, setFreightTab] = useState<TabTypesEnum | undefined>(
    isAdmin ? undefined : TabTypesEnum.INTERNAL,
  );

  const [freights, setFreights] = useState<GetFreightsResponse>({
    rows: [],
    totalRecords: 0,
    page: 1,
    numberCargo: '',
  });

  const onNavigationClick = (path: string) => {
    history.push(path);
  };

  const handleOpenModal = async () => {
    setModalOpen(true);
  };

  const populateFreights = async () => {
    const freightTypes = isAdmin
      ? undefined
      : freightTab == TabTypesEnum.INTERNAL
        ? [freightTypeEnum.INTERNAL]
        : [freightTypeEnum.PRIVATE, freightTypeEnum.PUBLIC];

    const freight = await execute({
      page: currentPage,
      rowsPerPage: rowsPerPage,
      status,
      startDate: period.startDate
        ? format(period.startDate, 'yyyy/MM/dd')
        : undefined,
      endDate: period.endDate
        ? format(period.endDate, 'yyyy/MM/dd')
        : undefined,
      freightTypes,
      numberCargo: searchLoadNumber,
    });

    if (!freight) return;

    setTotalRecords(freight.totalRecords);
    setFreights(freight);
  };

  const handleApplyFilter = async () => {
    setIsDatePickerOpen(false);
    populateFreights();
  };

  const handleSendNotification = (title: string, message: string) => {
    const result = sendNotification(title, message);
    if (!result) return;
    setModalOpen(false);
  };

  const handleClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleRedirectImport = () => {
    onNavigationClick(`/home/import`);
  };

  useEffect(() => {
    populateFreights();
    setMenuOpen(false);
  }, [currentPage, rowsPerPage, freightTab]);

  useEffect(() => {
    const loadDrivers = async () => {
      const drivers = await getDriver({
        page: currentPage,
        status: 'Ativo',
        rowsPerPage: 5,
      });
      if (!drivers) return;
      setDrivers(drivers);
    };
    loadDrivers();
  }, [currentPage]);

  const freightDriverIds = freights?.rows.map(
    (freight: any) => freight.driverDriverId,
  );
  const filteredDriver = drivers.rows.filter(
    (driver: any) => !freightDriverIds.includes(driver.driverId),
  );

  const renderHomeFreights = () => {
    return (
      <BoxWrapper>
        <Grid container alignContent="stretch" spacing={2}>
          <Grid item xs="auto">
            <ButtonComponent theme="primary" onClick={handleClick}>
              <img src={FilterIcon} alt="Filter" className={classes.icon} />
              Filtrar
            </ButtonComponent>
          </Grid>

          <Grid item style={{ flex: 1 }}>
            <Paper
              component="form"
              elevation={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '40px',
                border: '1px solid #FF7206',
                backgroundColor: '#F7F9FC',
              }}
            >
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  fontFamily: commons.fontFamily,
                }}
                placeholder="Buscar nº de frete ou Nome do motorista"
                type="text"
                onChange={event => setSeachLoadNumber(event.target.value)}
                className="input-filter"
                value={searchLoadNumber}
                inputProps={{ maxLength: 30 }}
              />
              <IconButton
                type="button"
                sx={{ p: '10px' }}
                aria-label="Pesquisar"
                onClick={populateFreights}
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>
          {!isAdmin && (
            <Grid item>
              <ButtonComponent theme="primary" onClick={handleRedirectImport}>
                <img src={ImportIcon} alt="Import" className={classes.icon} />
                Nova importação
              </ButtonComponent>
            </Grid>
          )}
        </Grid>
        {menuOpen && (
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <DateRangerCustom
                label={'Período'}
                value={period}
                onChange={newPeriod => setPeriod(newPeriod)}
                isPickerOpen={isDatePickerOpen}
                setIsPickerOpen={setIsDatePickerOpen}
              />
            </Grid>

            <Grid item xs={6}>
              <SelectCustom
                size="small"
                label={'Status'}
                defaultValue={'Selecione um status'}
                options={Object.values(FreightStatus)
                  .sort((a, b) => {
                    if (a === FreightStatus.ALL) {
                      return -1;
                    } else if (b === FreightStatus.ALL) {
                      return 1;
                    } else {
                      return a.localeCompare(b);
                    }
                  })
                  .map(value => ({
                    value: value,
                    label: value,
                  }))}
                value={status}
                onChange={event =>
                  setStatus((event.target as HTMLInputElement)?.value)
                }
              />
            </Grid>

            <Grid item xs={2}>
              <ButtonComponent
                theme="primary"
                mt={6}
                justifyContent="none"
                onClick={handleApplyFilter}
              >
                Aplicar filtro
              </ButtonComponent>
            </Grid>
          </Grid>
        )}
        <hr />
        {loading ? (
          <ActivityIndicator />
        ) : (
          <>
            <Table
              columns={
                freightTab == TabTypesEnum.INTERNAL
                  ? INTERNAL_FREIGHTS_HEADERS
                  : FREIGHTS_HEADERS
              }
              data={freights?.rows}
              onViewClick={(id: string) =>
                onNavigationClick(`/home/shippings/view/${id}`)
              }
              onSendNotification={handleOpenModal}
              notShowInput={true}
            />
            <Grid container justifyContent="space-between">
              <Grid item>
                <ItemsPerPageSelect
                  label={'Mostrar'}
                  value={rowsPerPage}
                  onChange={setRowsPerPage}
                />
              </Grid>
              <Grid item>
                <Pagination
                  totalRecords={totalRecords ?? freights?.totalRecords}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                />
              </Grid>
            </Grid>
          </>
        )}
      </BoxWrapper>
    );
  };

  return (
    <>
      <ModalDriverNotification
        open={modalOpen}
        setOpen={setModalOpen}
        onClick={() => handleSendNotification('title', 'message')}
        drivers={filteredDriver}
      />

      <Snackbar
        open={deleteFreightLoading}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="info">Excluindo frete...</Alert>
      </Snackbar>

      <Snackbar
        open={showDeleteMessage}
        autoHideDuration={3000}
        onClose={() => setShowDeleteMessage(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success">Frete excluído com sucesso!</Alert>
      </Snackbar>

      {isAdmin ? (
        renderHomeFreights()
      ) : (
        <TabContext value={freightTab as string}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabListCustom
              onChange={(event, value) => setFreightTab(value)}
              indicatorColor="primary"
              variant="fullWidth"
            >
              <TabCustom label="Fretes da casa" value={TabTypesEnum.INTERNAL} />
              <TabCustom
                label="Fretes terceirizados"
                value={TabTypesEnum.OUTSOURCE}
              />
            </TabListCustom>
          </Box>
          <TabPanel
            value={TabTypesEnum.INTERNAL}
            style={{ padding: 0, marginTop: 20 }}
          >
            {renderHomeFreights()}
          </TabPanel>
          <TabPanel
            value={TabTypesEnum.OUTSOURCE}
            style={{ padding: 0, marginTop: 20 }}
          >
            {renderHomeFreights()}
          </TabPanel>
        </TabContext>
      )}
    </>
  );
};

export default TableFreights;
